// extracted by mini-css-extract-plugin
export default {"add":"control_add__jO4G-","tooltip":"control_tooltip__0kVUO"};